import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { countriesDatabase } from "../data/countriesDatabase";
// import topSchools1 from "../assets/img/ukTop1.png";
import School from "../assets/School.svg";
import Peace from "../assets/Peace.svg";
import Research from "../assets/Research.svg";
import Books from "../assets/Books.svg";
import CountryTabs from "../components/CountryTabs";
// import bg from "../assets/img/studyBg.png"

function CountryDetailPage() {
  const navigate = useNavigate();
  const { countryCode } = useParams();
  const country = countriesDatabase[countryCode];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  if (!country) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <h2 className="text-3xl text-red-600">Country Not Found</h2>
      </div>
    );
  }
  return (
    <div className="container mx-auto">
       <div className="block bg-white h-[130px]"></div>
      <div className="container mx-auto px-4">
        <div className="relative bg-dark-neutral w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
          <img
            src={country.thumbnail}
            alt="Background"
            className="w-full h-full opacity-40 object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
          />

          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
              {country.flag} {country.name}
            </h1>
          </div>
        </div>
        <button
                onClick={() => navigate(-1)}
                className="text-primary rounded-full gap-2 mt-6 px-8 py-2 border border-gray-300 hover:bg-gray-50 transition-colors"
              >
                Go Back
              </button>
        <div className="container mx-auto py-12 my-8 md:my-20 flex flex-col md:flex-row">
          <div className="md:hidden mb-6">
            <img
              src={country.topSchools[0]}
              alt="top schools"
              className="w-full h-full rounded-2xl"
            />
          </div>

          <div className="hidden md:flex gap-4  h-[400px] items-center ">
            <div
              className={`relative overflow-hidden rounded-2xl transition-all duration-500 ease-in-out cursor-pointer
            ${
              hoveredIndex === 0
                ? "w-2/5"
                : hoveredIndex === null
                ? "w-2/5"
                : "w-1/5"
            }`}
              onMouseEnter={() => setHoveredIndex(0)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className={`w-full h-[500px] transition-all duration-500 ease-in-out
            ${hoveredIndex === 0 ? "scale-100" : "scale-150 translate-x-1/4"}`}
              >
                <img
                  src={country.topSchools[0]}
                  alt="School"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 p-4 text-white">
                  <h3 className="text-xl font-semibold">
                    {country.regions[0].school1}
                  </h3>
                </div>
              </div>
            </div>

            <div
              className={`relative overflow-hidden rounded-2xl transition-all duration-500 ease-in-out cursor-pointer
            ${hoveredIndex === 1 ? "w-2/5" : "w-1/5"}`}
              onMouseEnter={() => setHoveredIndex(1)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className={`w-full h-[500px] transition-all duration-500 ease-in-out
            ${hoveredIndex === 1 ? "scale-100" : "scale-150 translate-y-1/4"}`}
              >
                <img
                  src={country.topSchools[1]}
                  alt="school"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 p-4 text-white">
                  <h3 className="text-xl font-semibold">
                    {country.regions[0].school2}
                  </h3>
                  {/* <p className="text-sm">Leadership Conference 2023</p> */}
                </div>
              </div>
            </div>

            <div
              className={`relative hidden md:block overflow-hidden rounded-2xl transition-all duration-500 ease-in-out cursor-pointer
            ${hoveredIndex === 2 ? "w-2/5" : "w-1/5"}`}
              onMouseEnter={() => setHoveredIndex(2)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className={`w-full h-[500px] transition-all duration-500 ease-in-out
            ${hoveredIndex === 2 ? "scale-100" : "scale-150 -translate-x-1/4"}`}
              >
                <img
                  src={country.topSchools[2]}
                  alt="School"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 p-4 text-white">
                  <h3 className="text-xl font-semibold">
                    {country.regions[0].school3}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full">
            <h2 className="text-primary capitalize text-4xl font-bold mb-4">
              study at top universities in {country.name}
            </h2>
            <p className="text-base opacity-60 mb-12">
              {/* Join our students in the top most sought after universities in{" "} */}
              {country.schDescription}
            </p>
            <a
              href="/application"
              className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
            >
              start application
            </a>
          </div>
        </div>

        <div className="mx-auto my-20">
          <h3 className="text-2xl md:text-4xl text-center font-bold text-primary">
            Why Study in {country.name}
          </h3>
          <p className="mx-auto md:w-2/4 py-8 text-center  opacity-60">
           {country.whyStudy}
          </p>

          <div className="mt-8 flex flex-wrap gap-3 justify-around">
            <div className="border border-gray-neutral w-full max-w-[270px] p-6 rounded-2xl">
              <img src={School} alt="university" />
              <h4 className="capitalize py-3 text-primary font-bold text-lg">
                {country.whyStudy1.title}
              </h4>
              <p className="text-xs opacity-80">
              {country.whyStudy1.body}
              </p>
            </div>
            <div className="border border-gray-neutral w-full max-w-[270px] p-6 rounded-2xl">
              <img src={Books} alt="university" />
              <h4 className="capitalize py-3 text-primary font-bold text-lg">
              {country.whyStudy2.title}
              </h4>
              <p className="text-xs opacity-80">
              {country.whyStudy2.body}
              </p>
            </div>
            <div className="border border-gray-neutral w-full max-w-[270px] p-6 rounded-2xl">
              <img src={Research} alt="university" />
              <h4 className="capitalize py-3 text-primary font-bold text-lg">
              {country.whyStudy3.title}
              </h4>
              <p className="text-xs opacity-80">
              {country.whyStudy3.body}
              </p>
            </div>
            <div className="border border-gray-neutral w-full max-w-[270px] p-6 rounded-2xl">
              <img src={Peace} alt="university" />
              <h4 className="capitalize py-3 text-primary font-bold text-lg">
              {country.whyStudy4.title}
              </h4>
              <p className="text-xs opacity-80">
              {country.whyStudy4.body}
              </p>
            </div>
          </div>
        </div>

        <div className="my-20">
          <CountryTabs />
        </div>
      </div>
    </div>
  );
}

export default CountryDetailPage;
